<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-4">
            <a @click="openPage('/allForm/addFreeze')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="d-flex justify-content-center" v-if="loadingData">
          <div class="spinner-border" role="status">
            <span class="visually-hidden"></span>
          </div>
        </div>
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(name)="data">
<!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">
              {{data.item.member.first_name}} {{data.item.member.last_name}}
            </template>
            <template v-else-if="data.item.form_type.id == 6">
              {{data.item.daily_visit_name}}
            </template>
            <template v-else-if="data.item.form_type.id == 3">
              {{data.item.lost_and_found_name}}
            </template>
          </template>
          <template v-slot:cell(phone_number)="data">
<!--          <template slot="phone_number" slot-scope="data">-->
            <template v-if="data.item.member">
              {{data.item.member.phone_number}}
            </template>
            <template v-else-if="data.item.form_type.id == 6">
              {{data.item.daily_visit_phone_number}}
            </template>
          </template>
          <template v-slot:cell(date)="data">
<!--          <template slot="date" slot-scope="data">-->
            {{parseDate(data.item.created_at)}}
          </template>
          <template v-slot:cell(time)="data">
<!--          <template slot="time" slot-scope="data">-->
            {{parseTime(data.item.created_at)}}
          </template>
          <template v-slot:cell(is_agree)="data">
            <template v-if="data.item.form_type_id == 1 || data.item.form_type_id == 5 || data.item.form_type_id == 2">
              <b-badge v-if="data.item.is_agree == 1" :variant="'success'" >Success</b-badge>
              <b-badge v-if="data.item.is_agree == 0"  :variant="'warning'" >Waiting...</b-badge>
            </template>
          </template>
          <template v-slot:cell(actions)="data">
<!--          <template slot="actions" slot-scope="data">-->
            <template v-if="data.item.form_type_id == 3">
              <b-button size="sm" @click="editForm('/allForm/editLostAndFound?id=' + data.item.form_id)" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <template v-if="data.item.form_type_id == 5">
              <b-button size="sm" @click="editForm('/allForm/editFreeze?id=' + data.item.form_id)" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <template v-if="data.item.form_type_id == 1">
              <b-button size="sm" @click="editForm('/allForm/editCancel?id=' + data.item.form_id)" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <template v-if="data.item.form_type_id == 7 && data.item.product_type_id == 1">
              <b-button size="sm" @click="editForm('/allForm/editGrabAndGo?id=' + data.item.form_id)" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <template v-if="data.item.form_type_id == 7 && data.item.product_type_id == 2">
              <b-button size="sm" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <template v-if="data.item.form_type_id == 8">
              <b-button size="sm" @click="editForm('/allForm/editGrabAndGoGopay?id=' + data.item.form_id)" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'allForm',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'form_type.name',
          label: 'Type Form',
          sortable: true
        },
        {
          key: 'name',
          label: 'Member Name',
          sortable: true
        },
        {
          key: 'date',
          label: 'Date',
          sortable: true
        },
        {
          key: 'time',
          label: 'Time',
          sortable: true
        },
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'is_agree',
          label: 'Agreement',
          sortable: true
        },
        {
          key: 'detail_reason',
          label: 'Detail',
          sortable: true
        },
        {
          key: 'status_category',
          label: 'Category Status',
          formatter: (value, key, item) => {
            let status = item.member ? item.member.membership_status_id : null
            if (status != null) {
              if (status == 3) {
                return 'Cancel'
              }
              if (status == 5) {
                return 'Terminated'
              }
            } else {
              return ''
            }
          },
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: true
        }
      ],
      loadingData: false,
      items: [],
      dataBranch: [],
      branch_id: null,
      getId: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY')
    },
    parseTime (value) {
      moment.locale('en')
      return moment(value).format('h:mm a')
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteForm(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/form/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    changeBranch(event) {
      let url = 'crm/v1/form_master?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData

      if (event != null)
        url = url + '&branch_id=' + event

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      this.loadingData = true
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token

      let url = 'crm/v1/form_master?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData

      if (this.branch_id != null)
        url = url + '&branch_id=' + this.branch_id

      axios.get(url).then(response => {
        this.loadingData = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        this.loadingData = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
